import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _activity = { createdDate: 'google.protobuf.Timestamp' };
var _addActivitiesRequest = {};
var _addActivitiesResponse = { order: '_order' };
var _addActivityRequest = {};
var _addActivityResponse = { order: '_order' };
var _addInternalActivityRequest = { activity: '_internalActivity' };
var _addInternalActivityResponse = { order: '_order' };
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _addressWithContact = { address: '_address' };
var _aggregateOrdersRequest = {};
var _aggregateOrdersResponse = {};
var _archiveOrderRequest = {};
var _archiveOrderResponse = { order: '_order' };
var _authorizationCapture = { createdDate: 'google.protobuf.Timestamp' };
var _authorizationDetails = {
    authorizedDate: 'google.protobuf.Timestamp',
    captures: '_authorizationCapture',
    void: '_authorizationVoid',
    scheduledAction: '_v1ScheduledAction',
};
var _authorizationVoid = { voidedDate: 'google.protobuf.Timestamp' };
var _bulkArchiveOrdersByFilterRequest = {};
var _bulkArchiveOrdersByFilterResponse = { results: '_bulkOrderResult' };
var _bulkArchiveOrdersRequest = {};
var _bulkArchiveOrdersResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsFulfilledByFilterRequest = {};
var _bulkMarkAsFulfilledByFilterResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsFulfilledRequest = {};
var _bulkMarkAsFulfilledResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsUnfulfilledByFilterRequest = {};
var _bulkMarkAsUnfulfilledByFilterResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsUnfulfilledRequest = {};
var _bulkMarkAsUnfulfilledResponse = { results: '_bulkOrderResult' };
var _bulkMarkOrdersAsPaidRequest = {};
var _bulkMarkOrdersAsPaidResponse = { results: '_bulkOrderResult' };
var _bulkOrderResult = { item: '_order' };
var _bulkSendBuyerPickupConfirmationEmailsRequest = {};
var _bulkSendBuyerPickupConfirmationEmailsResponse = {};
var _bulkSendBuyerShippingConfirmationEmailsRequest = {};
var _bulkSendBuyerShippingConfirmationEmailsResponse = {};
var _bulkSetBusinessLocationRequest = {};
var _bulkSetBusinessLocationResponse = {};
var _bulkUnArchiveOrdersByFilterRequest = {};
var _bulkUnArchiveOrdersByFilterResponse = { results: '_bulkOrderResult' };
var _bulkUnArchiveOrdersRequest = {};
var _bulkUnArchiveOrdersResponse = { results: '_bulkOrderResult' };
var _bulkUpdateOrdersRequest = { orders: '_maskedOrder' };
var _bulkUpdateOrdersResponse = { results: '_bulkOrderResult' };
var _bulkUpdateOrderTagsRequest = {};
var _bulkUpdateOrderTagsResponse = {};
var _calculateRefundRequest = {};
var _calculateRefundResponse = {};
var _cancelOrderRequest = {};
var _cancelOrderResponse = { order: '_order' };
var _captureAuthorizedPaymentsRequest = {};
var _captureAuthorizedPaymentsResponse = {
    orderTransactions: '_orderTransactions',
};
var _chargeback = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _chargeMembershipsRequest = {
    membershipCharges: '_membershipChargeItem',
};
var _chargeMembershipsResponse = {};
var _chargeSavedPaymentMethodRequest = {};
var _chargeSavedPaymentMethodResponse = {};
var _commitDeltasRequest = { changes: '_draftOrderDiffs' };
var _commitDeltasResponse = { order: '_order' };
var _createOrderRequest = { order: '_order' };
var _createOrderResponse = { order: '_order' };
var _createPaymentGatewayOrderRequest = {};
var _createPaymentGatewayOrderResponse = {};
var _decrementItemsQuantityRequest = {};
var _decrementItemsQuantityResponse = { order: '_order' };
var _deleteActivityRequest = {};
var _deleteActivityResponse = { order: '_order' };
var _deliveryLogistics = {
    deliverByDate: 'google.protobuf.Timestamp',
    shippingDestination: '_addressWithContact',
    pickupDetails: '_pickupDetails',
    deliveryTimeSlot: '_deliveryTimeSlot',
};
var _deliveryTimeSlot = {
    from: 'google.protobuf.Timestamp',
    to: 'google.protobuf.Timestamp',
};
var _digitalFile = { expirationDate: 'google.protobuf.Timestamp' };
var _draftOrderDiffs = {
    changedShippingInfo: '_shippingInformation',
    changedBillingInfo: '_addressWithContact',
    changedRecipientInfo: '_addressWithContact',
    lineItems: '_lineItemDelta',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getOrderRequest = {};
var _getOrderResponse = { order: '_order' };
var _getPaymentCollectabilityStatusRequest = {};
var _getPaymentCollectabilityStatusResponse = {};
var _getRefundabilityStatusRequest = {};
var _getRefundabilityStatusResponse = {};
var _getShipmentsRequest = {};
var _getShipmentsResponse = {};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _internalActivity = { createdDate: 'google.protobuf.Timestamp' };
var _internalQueryOrdersRequest = {};
var _internalQueryOrdersResponse = { orders: '_order' };
var _lineItemDelta = { lineItem: '_orderLineItemChangedDetails' };
var _markAsFulfilledRequest = {};
var _markAsFulfilledResponse = { order: '_order' };
var _markAsUnfulfilledRequest = {};
var _markAsUnfulfilledResponse = { order: '_order' };
var _markOrderAsPaidRequest = {};
var _markOrderAsPaidResponse = { order: '_order' };
var _markOrderAsSeenByHumanRequest = {};
var _markOrderAsSeenByHumanResponse = { order: '_order' };
var _maskedOrder = {
    fieldMask: 'google.protobuf.FieldMask',
    order: '_order',
};
var _maskedOrderLineItem = {
    fieldMask: 'google.protobuf.FieldMask',
    lineItem: '_orderLineItem',
};
var _membershipChargeItem = { serviceProperties: '_serviceProperties' };
var _order = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    purchasedDate: 'google.protobuf.Timestamp',
    lineItems: '_orderLineItem',
    billingInfo: '_addressWithContact',
    shippingInfo: '_shippingInformation',
    activities: '_activity',
    recipientInfo: '_addressWithContact',
};
var _orderLineItem = {
    image: '_image',
    physicalProperties: '_physicalProperties',
    digitalFile: '_digitalFile',
    subscriptionInfo: '_subscriptionInfo',
};
var _orderLineItemChangedDetails = {
    image: '_image',
    physicalProperties: '_physicalProperties',
    digitalFile: '_digitalFile',
    subscriptionInfo: '_subscriptionInfo',
};
var _orderTransactions = { payments: '_v1Payment', refunds: '_refund' };
var _physicalProperties = { weight: 'google.protobuf.DoubleValue' };
var _pickupAddress = { geocode: '_addressLocation' };
var _pickupDetails = { address: '_pickupAddress' };
var _preparePaymentCollectionRequest = {};
var _preparePaymentCollectionResponse = {};
var _previewBuyerConfirmationEmailRequest = {};
var _previewBuyerConfirmationEmailResponse = {};
var _previewBuyerPaymentsReceivedEmailRequest = {};
var _previewBuyerPaymentsReceivedEmailResponse = {};
var _previewBuyerPickupConfirmationEmailRequest = {};
var _previewBuyerPickupConfirmationEmailResponse = {};
var _previewCancelEmailRequest = {};
var _previewCancelEmailResponse = {};
var _previewCancelRefundEmailRequest = {};
var _previewCancelRefundEmailResponse = {};
var _previewEmailByTypeRequest = {};
var _previewEmailByTypeResponse = {};
var _previewRefundEmailRequest = {};
var _previewRefundEmailResponse = {};
var _previewResendDownloadLinksEmailRequest = {};
var _previewResendDownloadLinksEmailResponse = {};
var _previewShippingConfirmationEmailRequest = {};
var _previewShippingConfirmationEmailResponse = {};
var _queryOrderRequest = {};
var _queryOrderResponse = { orders: '_order' };
var _recordManuallyCollectedPaymentRequest = {};
var _recordManuallyCollectedPaymentResponse = {};
var _refund = { createdDate: 'google.protobuf.Timestamp' };
var _regularPaymentDetails = {
    authorizationDetails: '_authorizationDetails',
    chargebacks: '_chargeback',
};
var _searchOrdersRequest = {};
var _searchOrdersResponse = { orders: '_order' };
var _sendBuyerConfirmationEmailRequest = {};
var _sendBuyerConfirmationEmailResponse = {};
var _sendBuyerPaymentsReceivedEmailRequest = {};
var _sendBuyerPaymentsReceivedEmailResponse = {};
var _sendBuyerPickupConfirmationEmailRequest = {};
var _sendBuyerPickupConfirmationEmailResponse = {};
var _sendBuyerShippingConfirmationEmailRequest = {};
var _sendBuyerShippingConfirmationEmailResponse = {};
var _sendCancelRefundEmailRequest = {};
var _sendCancelRefundEmailResponse = {};
var _sendMerchantOrderReceivedNotificationRequest = {};
var _sendMerchantOrderReceivedNotificationResponse = {};
var _sendMerchantOrderReceivedPushRequest = {};
var _sendMerchantOrderReceivedPushResponse = {};
var _serviceProperties = { scheduledDate: 'google.protobuf.Timestamp' };
var _shippingInformation = { logistics: '_deliveryLogistics' };
var _subscriptionInfo = { subscriptionSettings: '_subscriptionSettings' };
var _subscriptionSettings = { startDate: 'google.protobuf.Timestamp' };
var _triggerRefundRequest = {};
var _triggerRefundResponse = { orderTransactions: '_orderTransactions' };
var _triggerReindexRequest = {};
var _triggerReindexResponse = {};
var _unArchiveOrderRequest = {};
var _unArchiveOrderResponse = { order: '_order' };
var _updateActivityRequest = {};
var _updateActivityResponse = { order: '_order' };
var _updateBillingContactDetailsRequest = {
    fieldMask: 'google.protobuf.FieldMask',
};
var _updateBillingContactDetailsResponse = { order: '_order' };
var _updateBuyerEmailRequest = {};
var _updateBuyerEmailResponse = { order: '_order' };
var _updateBuyerInfoRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _updateBuyerInfoResponse = { order: '_order' };
var _updateLineItemsDescriptionLinesRequest = {};
var _updateLineItemsDescriptionLinesResponse = { order: '_order' };
var _updateOrderLineItemRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    lineItem: '_orderLineItem',
};
var _updateOrderLineItemResponse = { order: '_order' };
var _updateOrderLineItemsRequest = { lineItems: '_maskedOrderLineItem' };
var _updateOrderLineItemsResponse = { order: '_order' };
var _updateOrderRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    order: '_order',
};
var _updateOrderResponse = { order: '_order' };
var _updateOrderShippingAddressRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    shippingAddress: '_addressWithContact',
};
var _updateOrderShippingAddressResponse = { order: '_order' };
var _updateOrderStatusRequest = {};
var _updateOrderStatusResponse = { order: '_order' };
var _v1BulkMarkOrdersAsPaidRequest = {};
var _v1BulkMarkOrdersAsPaidResponse = { results: '_bulkOrderResult' };
var _v1CreatePaymentGatewayOrderRequest = {};
var _v1CreatePaymentGatewayOrderResponse = {};
var _v1MarkOrderAsPaidRequest = {};
var _v1MarkOrderAsPaidResponse = { order: '_order' };
var _v1Payment = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    regularPaymentDetails: '_regularPaymentDetails',
};
var _v1ScheduledAction = { executionDate: 'google.protobuf.Timestamp' };
var _voidAuthorizedPaymentsRequest = {};
var _voidAuthorizedPaymentsResponse = {
    orderTransactions: '_orderTransactions',
};
function resolveComWixEcomOrdersV1OrdersUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/ecom-orders',
                destPath: '',
            },
            {
                srcPath: '/_api/orders',
                destPath: '',
            },
            {
                srcPath: '/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/ecom/v1/bulk/orders',
                destPath: '/v1/bulk/orders',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/ecom-orders',
                destPath: '',
            },
            {
                srcPath: '/_api/ep-orders',
                destPath: '/api',
            },
            {
                srcPath: '/ecom/v1/ep-orders',
                destPath: '/v1/orders',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/bulk/orders',
                destPath: '/v1/bulk/orders',
            },
            {
                srcPath: '/ecom/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/ecom/v1/ep-orders',
                destPath: '/v1/orders',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/ecom/v1/bulk/orders',
                destPath: '/v1/bulk/orders',
            },
            {
                srcPath: '/ecom/v1/orders',
                destPath: '/v1/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersIndexerV1EpOrdersIndexerUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/payments-collector',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/payments-collector',
                destPath: '/v1/payments-collector',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/ecom/v1/payments-collector',
                destPath: '/v1/payments-collector',
            },
            {
                srcPath: '/_api/v1/payments-collector',
                destPath: '/v1/payments-collector',
            },
            {
                srcPath: '/v1/payments-collector',
                destPath: '/v1/payments-collector',
            },
            {
                srcPath: '/_api/payments-collector',
                destPath: '/v1/payments-collector',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/orders/notifications',
                destPath: '/v1/orders/notifications',
            },
            {
                srcPath: '/ecom/v1/bulk/orders/notifications',
                destPath: '/v1/bulk/orders/notifications',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/order-notifications',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/order-notifications',
                destPath: '',
            },
            {
                srcPath: '/ecom/v1/orders/notifications',
                destPath: '/v1/orders/notifications',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function sendBuyerConfirmationEmail(payload) {
    var _a = serializer(_sendBuyerConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerConfirmationEmailResponse, {}).fromJSON;
    function __sendBuyerConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerConfirmationEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-confirmation-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerConfirmationEmail.fromReq = fromReq;
    __sendBuyerConfirmationEmail.__isAmbassador = true;
    return __sendBuyerConfirmationEmail;
}
export function sendBuyerPaymentsReceivedEmail(payload) {
    var _a = serializer(_sendBuyerPaymentsReceivedEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerPaymentsReceivedEmailResponse, {}).fromJSON;
    function __sendBuyerPaymentsReceivedEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerPaymentsReceivedEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-payments-received-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerPaymentsReceivedEmail.fromReq = fromReq;
    __sendBuyerPaymentsReceivedEmail.__isAmbassador = true;
    return __sendBuyerPaymentsReceivedEmail;
}
export function sendBuyerPickupConfirmationEmail(payload) {
    var _a = serializer(_sendBuyerPickupConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerPickupConfirmationEmailResponse, {}).fromJSON;
    function __sendBuyerPickupConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerPickupConfirmationEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-pickup-confirmation-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerPickupConfirmationEmail.fromReq = fromReq;
    __sendBuyerPickupConfirmationEmail.__isAmbassador = true;
    return __sendBuyerPickupConfirmationEmail;
}
/** @deprecated Will be removed on 2025-03-02. */
export function bulkSendBuyerPickupConfirmationEmails(payload) {
    var _a = serializer(_bulkSendBuyerPickupConfirmationEmailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkSendBuyerPickupConfirmationEmailsResponse, {}).fromJSON;
    function __bulkSendBuyerPickupConfirmationEmails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.BulkSendBuyerPickupConfirmationEmails',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/bulk/orders/notifications/send-buyer-pickup-confirmation-emails',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkSendBuyerPickupConfirmationEmails.fromReq = fromReq;
    __bulkSendBuyerPickupConfirmationEmails.__isAmbassador = true;
    return __bulkSendBuyerPickupConfirmationEmails;
}
export function sendBuyerShippingConfirmationEmail(payload) {
    var _a = serializer(_sendBuyerShippingConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerShippingConfirmationEmailResponse, {}).fromJSON;
    function __sendBuyerShippingConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerShippingConfirmationEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-shipping-confirmation-mail/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerShippingConfirmationEmail.fromReq = fromReq;
    __sendBuyerShippingConfirmationEmail.__isAmbassador = true;
    return __sendBuyerShippingConfirmationEmail;
}
/** @deprecated Will be removed on 2025-03-02. */
export function bulkSendBuyerShippingConfirmationEmails(payload) {
    var _a = serializer(_bulkSendBuyerShippingConfirmationEmailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkSendBuyerShippingConfirmationEmailsResponse, {}).fromJSON;
    function __bulkSendBuyerShippingConfirmationEmails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.BulkSendBuyerShippingConfirmationEmails',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/bulk/orders/notifications/send-buyer-shipping-confirmation-emails',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkSendBuyerShippingConfirmationEmails.fromReq = fromReq;
    __bulkSendBuyerShippingConfirmationEmails.__isAmbassador = true;
    return __bulkSendBuyerShippingConfirmationEmails;
}
/** this will send notification to merchant via both email and via Notification Hub */
export function sendMerchantOrderReceivedNotification(payload) {
    var _a = serializer(_sendMerchantOrderReceivedNotificationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendMerchantOrderReceivedNotificationResponse, {}).fromJSON;
    function __sendMerchantOrderReceivedNotification(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendMerchantOrderReceivedNotification',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-merchant-order-received-notification/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendMerchantOrderReceivedNotification.fromReq = fromReq;
    __sendMerchantOrderReceivedNotification.__isAmbassador = true;
    return __sendMerchantOrderReceivedNotification;
}
export function sendCancelRefundEmail(payload) {
    var _a = serializer(_sendCancelRefundEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendCancelRefundEmailResponse, {}).fromJSON;
    function __sendCancelRefundEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendCancelRefundEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-cancel-refund-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendCancelRefundEmail.fromReq = fromReq;
    __sendCancelRefundEmail.__isAmbassador = true;
    return __sendCancelRefundEmail;
}
export function sendMerchantOrderReceivedPush(payload) {
    var _a = serializer(_sendMerchantOrderReceivedPushRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendMerchantOrderReceivedPushResponse, {}).fromJSON;
    function __sendMerchantOrderReceivedPush(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendMerchantOrderReceivedPush',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-merchant-order-received-push/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendMerchantOrderReceivedPush.fromReq = fromReq;
    __sendMerchantOrderReceivedPush.__isAmbassador = true;
    return __sendMerchantOrderReceivedPush;
}
/** @deprecated Will be removed on 2025-03-02. */
export function previewEmailByType(payload) {
    var _a = serializer(_previewEmailByTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewEmailByTypeResponse, {}).fromJSON;
    function __previewEmailByType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewEmailByType',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/{emailType}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewEmailByType.fromReq = fromReq;
    __previewEmailByType.__isAmbassador = true;
    return __previewEmailByType;
}
export function previewRefundEmail(payload) {
    var _a = serializer(_previewRefundEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewRefundEmailResponse, {}).fromJSON;
    function __previewRefundEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewRefundEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewRefundEmail.fromReq = fromReq;
    __previewRefundEmail.__isAmbassador = true;
    return __previewRefundEmail;
}
export function previewCancelEmail(payload) {
    var _a = serializer(_previewCancelEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewCancelEmailResponse, {}).fromJSON;
    function __previewCancelEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewCancelEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewCancelEmail.fromReq = fromReq;
    __previewCancelEmail.__isAmbassador = true;
    return __previewCancelEmail;
}
export function previewCancelRefundEmail(payload) {
    var _a = serializer(_previewCancelRefundEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewCancelRefundEmailResponse, {}).fromJSON;
    function __previewCancelRefundEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewCancelRefundEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/cancel-refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewCancelRefundEmail.fromReq = fromReq;
    __previewCancelRefundEmail.__isAmbassador = true;
    return __previewCancelRefundEmail;
}
export function previewBuyerPaymentsReceivedEmail(payload) {
    var _a = serializer(_previewBuyerPaymentsReceivedEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewBuyerPaymentsReceivedEmailResponse, {}).fromJSON;
    function __previewBuyerPaymentsReceivedEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewBuyerPaymentsReceivedEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/buyer-payments-received',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewBuyerPaymentsReceivedEmail.fromReq = fromReq;
    __previewBuyerPaymentsReceivedEmail.__isAmbassador = true;
    return __previewBuyerPaymentsReceivedEmail;
}
/**
 * Deprecated, use PreviewEmailByType with ORDER_PLACED type instead
 * @deprecated
 */
export function previewBuyerConfirmationEmail(payload) {
    var _a = serializer(_previewBuyerConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewBuyerConfirmationEmailResponse, {}).fromJSON;
    function __previewBuyerConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewBuyerConfirmationEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/buyer-confirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewBuyerConfirmationEmail.fromReq = fromReq;
    __previewBuyerConfirmationEmail.__isAmbassador = true;
    return __previewBuyerConfirmationEmail;
}
/**
 * Deprecated, use PreviewEmailByType with ORDER_READY_FOR_PICKUP type instead
 * @deprecated
 */
export function previewBuyerPickupConfirmationEmail(payload) {
    var _a = serializer(_previewBuyerPickupConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewBuyerPickupConfirmationEmailResponse, {}).fromJSON;
    function __previewBuyerPickupConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewBuyerPickupConfirmationEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/buyer-pickup-confirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewBuyerPickupConfirmationEmail.fromReq = fromReq;
    __previewBuyerPickupConfirmationEmail.__isAmbassador = true;
    return __previewBuyerPickupConfirmationEmail;
}
/**
 * Deprecated, use PreviewEmailByType with ORDER_SHIPPED type instead
 * @deprecated
 */
export function previewShippingConfirmationEmail(payload) {
    var _a = serializer(_previewShippingConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewShippingConfirmationEmailResponse, {}).fromJSON;
    function __previewShippingConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewShippingConfirmationEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/shipping-confirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewShippingConfirmationEmail.fromReq = fromReq;
    __previewShippingConfirmationEmail.__isAmbassador = true;
    return __previewShippingConfirmationEmail;
}
/**
 * Deprecated, use PreviewEmailByType with DOWNLOAD_LINKS type instead
 * @deprecated
 */
export function previewResendDownloadLinksEmail(payload) {
    var _a = serializer(_previewResendDownloadLinksEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewResendDownloadLinksEmailResponse, {}).fromJSON;
    function __previewResendDownloadLinksEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewResendDownloadLinksEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/resend-download-link',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewResendDownloadLinksEmail.fromReq = fromReq;
    __previewResendDownloadLinksEmail.__isAmbassador = true;
    return __previewResendDownloadLinksEmail;
}
/**
 * Prepares payment collection for given ecom order. This is the first of 2-step process of payment collection.
 * Here we ensure that payment collection is possible for given order and store and prepare payment gateway order for future charge.
 * 2nd step is an actual charge of prepared payment gateway order. This could be done either
 * via Wix-Cashier's API (https://bo.wix.com/wix-docs/rest/wix-cashier/pay/charge/charge-for-order)
 * or using Cashier Payments Widget (https://github.com/wix-private/cashier-client/tree/master/packages/cashier-payments-widget)
 */
export function preparePaymentCollection(payload) {
    var _a = serializer(_preparePaymentCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_preparePaymentCollectionResponse, {}).fromJSON;
    function __preparePaymentCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.PreparePaymentCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/prepare-payment-collection',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __preparePaymentCollection.fromReq = fromReq;
    __preparePaymentCollection.__isAmbassador = true;
    return __preparePaymentCollection;
}
/**
 * Provides payment collectability status for given order. If payment collection is possible
 * response will contain collectable amount for given ecom order. If not - response will contain
 * reason why payment collection is not possible.
 */
export function getPaymentCollectabilityStatus(payload) {
    var _a = serializer(_getPaymentCollectabilityStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPaymentCollectabilityStatusResponse, {}).fromJSON;
    function __getPaymentCollectabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.GetPaymentCollectabilityStatus',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/payment-collectability-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPaymentCollectabilityStatus.fromReq = fromReq;
    __getPaymentCollectabilityStatus.__isAmbassador = true;
    return __getPaymentCollectabilityStatus;
}
/**
 * Records and approves new manual payment with provided custom amount on given order.
 * Existing pending payments are ignored.
 * Custom amount is expected to be less or equal remaining amount to be paid on order (affected by approved payments, refunds and gift card payments)
 */
export function recordManuallyCollectedPayment(payload) {
    var _a = serializer(_recordManuallyCollectedPaymentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_recordManuallyCollectedPaymentResponse, {}).fromJSON;
    function __recordManuallyCollectedPayment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.RecordManuallyCollectedPayment',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{orderId}/manual-payment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __recordManuallyCollectedPayment.fromReq = fromReq;
    __recordManuallyCollectedPayment.__isAmbassador = true;
    return __recordManuallyCollectedPayment;
}
/**
 * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
 * In case the order already has an offline payment transaction associated with it
 * (usually when manual payment method is chosen at checkout) - This transaction will become approved.
 * In case the order has no payment transactions associated with it
 * (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction
 * will be created and approved.
 */
export function paymentCollectionMarkOrderAsPaid(payload) {
    var _a = serializer(_v1MarkOrderAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1MarkOrderAsPaidResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __paymentCollectionMarkOrderAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.MarkOrderAsPaid',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __paymentCollectionMarkOrderAsPaid.fromReq = fromReq;
    __paymentCollectionMarkOrderAsPaid.__isAmbassador = true;
    return __paymentCollectionMarkOrderAsPaid;
}
/** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
export function paymentCollectionBulkMarkOrdersAsPaid(payload) {
    var _a = serializer(_v1BulkMarkOrdersAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1BulkMarkOrdersAsPaidResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __paymentCollectionBulkMarkOrdersAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.BulkMarkOrdersAsPaid',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/bulk/payments-collector/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __paymentCollectionBulkMarkOrdersAsPaid.fromReq = fromReq;
    __paymentCollectionBulkMarkOrdersAsPaid.__isAmbassador = true;
    return __paymentCollectionBulkMarkOrdersAsPaid;
}
/** Checks whether this order can be refunded. */
export function getRefundabilityStatus(payload) {
    var _a = serializer(_getRefundabilityStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRefundabilityStatusResponse, {}).fromJSON;
    function __getRefundabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.GetRefundabilityStatus',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/refundability',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRefundabilityStatus.fromReq = fromReq;
    __getRefundabilityStatus.__isAmbassador = true;
    return __getRefundabilityStatus;
}
/**
 * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
 * 1. An explicit amount provided in the request, or;
 * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
 * As a result, an ID of the created payment gateway order would be returned.
 * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
 */
export function paymentCollectionCreatePaymentGatewayOrder(payload) {
    var _a = serializer(_v1CreatePaymentGatewayOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1CreatePaymentGatewayOrderResponse, {}).fromJSON;
    function __paymentCollectionCreatePaymentGatewayOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.CreatePaymentGatewayOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/create-payment-gateway-order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __paymentCollectionCreatePaymentGatewayOrder.fromReq = fromReq;
    __paymentCollectionCreatePaymentGatewayOrder.__isAmbassador = true;
    return __paymentCollectionCreatePaymentGatewayOrder;
}
export function chargeMemberships(payload) {
    var _a = serializer(_chargeMembershipsRequest, { _membershipChargeItem: _membershipChargeItem, _serviceProperties: _serviceProperties }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_chargeMembershipsResponse, {}).fromJSON;
    function __chargeMemberships(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.ChargeMemberships',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/charge-membership',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __chargeMemberships.fromReq = fromReq;
    __chargeMemberships.__isAmbassador = true;
    return __chargeMemberships;
}
/**
 * Calls corresponding payment providers and creates refund transactions for requested payments.
 * Updates order transactions based on refund results.
 * For requested payments with `TriggerRefundRequest.payments.external_refund = true` will not call payment providers and
 * will only update order transactions.
 */
export function triggerRefund(payload) {
    var _a = serializer(_triggerRefundRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_triggerRefundResponse, {
        _authorizationCapture: _authorizationCapture,
        _authorizationDetails: _authorizationDetails,
        _authorizationVoid: _authorizationVoid,
        _chargeback: _chargeback,
        _orderTransactions: _orderTransactions,
        _refund: _refund,
        _regularPaymentDetails: _regularPaymentDetails,
        _v1Payment: _v1Payment,
        _v1ScheduledAction: _v1ScheduledAction,
    }).fromJSON;
    function __triggerRefund(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.TriggerRefund',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/trigger-refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerRefund.fromReq = fromReq;
    __triggerRefund.__isAmbassador = true;
    return __triggerRefund;
}
/** Calculates refundable amount for order items specified in request. */
export function calculateRefund(payload) {
    var _a = serializer(_calculateRefundRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateRefundResponse, {}).fromJSON;
    function __calculateRefund(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.CalculateRefund',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/calculate-refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateRefund.fromReq = fromReq;
    __calculateRefund.__isAmbassador = true;
    return __calculateRefund;
}
/**
 * Void authorized payments
 * Transaction statuses for related payments will be updated in async way
 */
export function voidAuthorizedPayments(payload) {
    var _a = serializer(_voidAuthorizedPaymentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_voidAuthorizedPaymentsResponse, {
        _authorizationCapture: _authorizationCapture,
        _authorizationDetails: _authorizationDetails,
        _authorizationVoid: _authorizationVoid,
        _chargeback: _chargeback,
        _orderTransactions: _orderTransactions,
        _refund: _refund,
        _regularPaymentDetails: _regularPaymentDetails,
        _v1Payment: _v1Payment,
        _v1ScheduledAction: _v1ScheduledAction,
    }).fromJSON;
    function __voidAuthorizedPayments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.VoidAuthorizedPayments',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/void-authorized-payments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __voidAuthorizedPayments.fromReq = fromReq;
    __voidAuthorizedPayments.__isAmbassador = true;
    return __voidAuthorizedPayments;
}
/**
 * Capture authorized payments
 * Transaction statuses for related payments will be updated in async way
 */
export function captureAuthorizedPayments(payload) {
    var _a = serializer(_captureAuthorizedPaymentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_captureAuthorizedPaymentsResponse, {
        _authorizationCapture: _authorizationCapture,
        _authorizationDetails: _authorizationDetails,
        _authorizationVoid: _authorizationVoid,
        _chargeback: _chargeback,
        _orderTransactions: _orderTransactions,
        _refund: _refund,
        _regularPaymentDetails: _regularPaymentDetails,
        _v1Payment: _v1Payment,
        _v1ScheduledAction: _v1ScheduledAction,
    }).fromJSON;
    function __captureAuthorizedPayments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.CaptureAuthorizedPayments',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/capture-authorized-payments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __captureAuthorizedPayments.fromReq = fromReq;
    __captureAuthorizedPayments.__isAmbassador = true;
    return __captureAuthorizedPayments;
}
export function chargeSavedPaymentMethod(payload) {
    var _a = serializer(_chargeSavedPaymentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_chargeSavedPaymentMethodResponse, {}).fromJSON;
    function __chargeSavedPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.ChargeSavedPaymentMethod',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/charge-saved-payment-method',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __chargeSavedPaymentMethod.fromReq = fromReq;
    __chargeSavedPaymentMethod.__isAmbassador = true;
    return __chargeSavedPaymentMethod;
}
export function triggerReindex(payload) {
    var _a = serializer(_triggerReindexRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_triggerReindexResponse, {}).fromJSON;
    function __triggerReindex(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.indexer.v1.EpOrdersIndexer.TriggerReindex',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersIndexerV1EpOrdersIndexerUrl({
                protoPath: '/v1/orders-indexer/{metasiteId}/reindex',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerReindex.fromReq = fromReq;
    __triggerReindex.__isAmbassador = true;
    return __triggerReindex;
}
/**
 * Retrieves an order with the provided ID.
 *
 * To retrieve an order's payment and refund details, including amounts, payment methods, and payment statuses,
 * pass the order ID to [List Transactions For Single Order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/list-transactions-for-single-order).
 */
export function getOrder(payload) {
    var _a = serializer(_getOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __getOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.GetOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrder.fromReq = fromReq;
    __getOrder.__isAmbassador = true;
    return __getOrder;
}
/**
 * <!--ONLY:REST-->
 * Internal query orders endpoint without additional logic to hide INIT orders.
 * Returns a list of up to 100 orders, given the provided paging, filtering and sorting.
 *
 * To learn how to query orders, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * <!--END:ONLY:REST-->
 */
export function internalQueryOrders(payload) {
    var _a = serializer(_internalQueryOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_internalQueryOrdersResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __internalQueryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.InternalQueryOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/internal/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __internalQueryOrders.fromReq = fromReq;
    __internalQueryOrders.__isAmbassador = true;
    return __internalQueryOrders;
}
/**
 * > **Note:** Use SearchOrders instead
 * Retrieves a list of orders, given the provided paging, filtering, and sorting.
 *
 *
 * Query Orders runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `DESC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 * - `filter: {"status": {"$ne": "INITIALIZED"}}` - other order statuses can be queried, but orders with `status: "INITIALIZED"` are never returned
 *
 * For field support for filters and sorting, see [Orders: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 * @deprecated It has been replaced with com.wix.ecom.orders.v1.Orders.SearchOrders(), and will be removed on 2025-03-02.
 */
export function queryOrders(payload) {
    var _a = serializer(_queryOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __queryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.QueryOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOrders.fromReq = fromReq;
    __queryOrders.__isAmbassador = true;
    return __queryOrders;
}
/**
 * Retrieves a list of orders, given the provided paging, filtering, and sorting.
 *
 *
 * Search Orders runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `DESC` order
 * - `cursorPaging.limit` is `100`
 * - `filter: {"status": {"$ne": "INITIALIZED"}}` - other order statuses can be queried, but orders with `status: "INITIALIZED"` are never returned
 *
 * For field support for filters and sorting, see [Orders: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/supported-filters-and-sorting).
 *
 * To learn about working with _Search_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function searchOrders(payload) {
    var _a = serializer(_searchOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchOrdersResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __searchOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.SearchOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchOrders.fromReq = fromReq;
    __searchOrders.__isAmbassador = true;
    return __searchOrders;
}
/**
 * Creates an order.
 *
 *
 * > **Notes:**
 * > + If an item is digital - `lineItems[i].itemType.preset: DIGITAL` - then `lineItems[i].digitalFile` must be provided.
 * > + If `lineItems[i].id` is passed, it must be either a valid GUID, or empty.
 */
export function createOrder(payload) {
    var _a = serializer(_createOrderRequest, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __createOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CreateOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrder.fromReq = fromReq;
    __createOrder.__isAmbassador = true;
    return __createOrder;
}
/**
 * Updates an order's properties.
 *
 * <blockquote class="important">
 *
 * <strong>Currently, only the following fields can be updated:</strong>
 * + `order.buyerInfo.email`
 * + `order.buyerLanguage`
 * + `order.weightUnit`
 * + `order.billingInfo.address`
 * + `order.billingInfo.contactDetails`
 * + `order.archived`
 * + `order.attributionSource`
 * + `order.seenByAHuman`
 * + `order.recipientInfo.address`
 * + `order.recipientInfo.contactDetails`
 * + `order.shippingInfo.logistics.shippingDestination.address`
 * + `order.shippingInfo.logistics.shippingDestination.contactDetails`
 * + `order.extendedFields`
 *
 * </blockquote>
 *
 * To update a field's value, include the new value in the `order` object in the body params.
 * To remove a field's value, pass `null`.
 *
 * > **Note:** Removing `buyerInfo` or `contactDetails` results in an error.
 *
 * To update an order's payment status, use [Update Payment Status](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/update-payment-status).
 */
export function updateOrder(payload) {
    var _a = serializer(_updateOrderRequest, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{order.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrder.fromReq = fromReq;
    __updateOrder.__isAmbassador = true;
    return __updateOrder;
}
/**
 * Updates properties of up to 100 orders.
 *
 * <blockquote class="important">
 *
 * __Currently, only the following fields can be updated:__
 * + `order.buyerInfo.email`
 * + `order.buyerLanguage`
 * + `order.weightUnit`
 * + `order.billingInfo.address`
 * + `order.billingInfo.contactDetails`
 * + `order.archived`
 * + `order.attributionSource`
 * + `order.seenByAHuman`
 * + `order.recipientInfo.address`
 * + `order.recipientInfo.contactDetails`
 * + `order.shippingInfo.logistics.shippingDestination.address`
 * + `order.shippingInfo.logistics.shippingDestination.contactDetails`
 * + `order.extendedFields`
 *
 * </blockquote>
 *
 *
 * To update a field's value, include the new value in the `order` object in the body params.
 * To remove a field's value, pass `null`.
 *
 * > **Note:** Removing (passing `null` to) `buyerInfo` or `contactDetails` results in an error.
 *
 * To update an order's payment status, use [Update Payment Status](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/update-payment-status).
 */
export function bulkUpdateOrders(payload) {
    var _a = serializer(_bulkUpdateOrdersRequest, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _maskedOrder: _maskedOrder,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateOrdersResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkUpdateOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkUpdateOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateOrders.fromReq = fromReq;
    __bulkUpdateOrders.__isAmbassador = true;
    return __bulkUpdateOrders;
}
export function commitDeltas(payload) {
    var _a = serializer(_commitDeltasRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _draftOrderDiffs: _draftOrderDiffs,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItemDelta: _lineItemDelta,
        _orderLineItemChangedDetails: _orderLineItemChangedDetails,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_commitDeltasResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __commitDeltas(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CommitDeltas',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/commit-deltas',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __commitDeltas.fromReq = fromReq;
    __commitDeltas.__isAmbassador = true;
    return __commitDeltas;
}
/** Archives an order. `order.archived` field changes to `true`. */
export function archiveOrder(payload) {
    var _a = serializer(_archiveOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_archiveOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __archiveOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.ArchiveOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archiveOrder.fromReq = fromReq;
    __archiveOrder.__isAmbassador = true;
    return __archiveOrder;
}
/** Archives multiple orders. `order.archived` field changes to `true`. */
export function bulkArchiveOrders(payload) {
    var _a = serializer(_bulkArchiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveOrdersResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkArchiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkArchiveOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveOrders.fromReq = fromReq;
    __bulkArchiveOrders.__isAmbassador = true;
    return __bulkArchiveOrders;
}
/** Archives multiple orders, selected by filter. `order.archived` field changes to `true`. */
export function bulkArchiveOrdersByFilter(payload) {
    var _a = serializer(_bulkArchiveOrdersByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveOrdersByFilterResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkArchiveOrdersByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkArchiveOrdersByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/archive-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveOrdersByFilter.fromReq = fromReq;
    __bulkArchiveOrdersByFilter.__isAmbassador = true;
    return __bulkArchiveOrdersByFilter;
}
/** Unarchives an order. `order.archived` field changes to `false`. */
export function unArchiveOrder(payload) {
    var _a = serializer(_unArchiveOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unArchiveOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __unArchiveOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UnArchiveOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unArchiveOrder.fromReq = fromReq;
    __unArchiveOrder.__isAmbassador = true;
    return __unArchiveOrder;
}
/** Unarchives multiple orders. `order.archived` field changes to `false`. */
export function bulkUnArchiveOrders(payload) {
    var _a = serializer(_bulkUnArchiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnArchiveOrdersResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkUnArchiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkUnArchiveOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnArchiveOrders.fromReq = fromReq;
    __bulkUnArchiveOrders.__isAmbassador = true;
    return __bulkUnArchiveOrders;
}
/** Unarchives multiple orders, selected by filter. `order.archived` field changes to `false`. */
export function bulkUnArchiveOrdersByFilter(payload) {
    var _a = serializer(_bulkUnArchiveOrdersByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnArchiveOrdersByFilterResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkUnArchiveOrdersByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkUnArchiveOrdersByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/unarchive-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnArchiveOrdersByFilter.fromReq = fromReq;
    __bulkUnArchiveOrdersByFilter.__isAmbassador = true;
    return __bulkUnArchiveOrdersByFilter;
}
/**
 * Updates an order's contact ID and/or email.
 * > **Note:** Neither `email`, nor `contactId` can be removed, only updated.
 */
export function updateBuyerInfo(payload) {
    var _a = serializer(_updateBuyerInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBuyerInfoResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateBuyerInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateBuyerInfo',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-buyer-info',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBuyerInfo.fromReq = fromReq;
    __updateBuyerInfo.__isAmbassador = true;
    return __updateBuyerInfo;
}
/** @deprecated Will be removed on 2023-09-25. */
export function updateBuyerEmail(payload) {
    var _a = serializer(_updateBuyerEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBuyerEmailResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateBuyerEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateBuyerEmail',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-buyer-email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBuyerEmail.fromReq = fromReq;
    __updateBuyerEmail.__isAmbassador = true;
    return __updateBuyerEmail;
}
/**
 * Updates an order's shipping address and/or contact details.
 * > **Notes:**
 * > + Original order must have existing address to update - `order.shippingInfo.logistics.shippingDestination.address` must have existing value.
 * > + Neither `address`, nor `contactDetails` can be removed, only updated.
 */
export function updateOrderShippingAddress(payload) {
    var _a = serializer(_updateOrderShippingAddressRequest, { _address: _address, _addressLocation: _addressLocation, _addressWithContact: _addressWithContact }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderShippingAddressResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateOrderShippingAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PUT',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrderShippingAddress',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-shipping-address',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderShippingAddress.fromReq = fromReq;
    __updateOrderShippingAddress.__isAmbassador = true;
    return __updateOrderShippingAddress;
}
/** Updates an order's billing contact details. */
export function updateBillingContactDetails(payload) {
    var _a = serializer(_updateBillingContactDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBillingContactDetailsResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateBillingContactDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PUT',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateBillingContactDetails',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-billing-contact-details',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBillingContactDetails.fromReq = fromReq;
    __updateBillingContactDetails.__isAmbassador = true;
    return __updateBillingContactDetails;
}
/** @deprecated Will be removed on 2024-02-15. */
export function updateOrderLineItem(payload) {
    var _a = serializer(_updateOrderLineItemRequest, {
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderLineItemResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateOrderLineItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrderLineItem',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/line-item/{lineItem.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderLineItem.fromReq = fromReq;
    __updateOrderLineItem.__isAmbassador = true;
    return __updateOrderLineItem;
}
/**
 * Updates multiple items of an order.
 * Currently, the following fields can be updated:
 * + `lineItem.productName`
 * + `lineItem.descriptionLines` (full replacement)
 * + `lineItem.digitalFile`
 * + `lineItem.priceDescription`
 */
export function updateOrderLineItems(payload) {
    var _a = serializer(_updateOrderLineItemsRequest, {
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _maskedOrderLineItem: _maskedOrderLineItem,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderLineItemsResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateOrderLineItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrderLineItems',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{orderId}/line-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderLineItems.fromReq = fromReq;
    __updateOrderLineItems.__isAmbassador = true;
    return __updateOrderLineItems;
}
export function addInternalActivity(payload) {
    var _a = serializer(_addInternalActivityRequest, { _internalActivity: _internalActivity }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addInternalActivityResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __addInternalActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AddInternalActivity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/add-internal-activity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addInternalActivity.fromReq = fromReq;
    __addInternalActivity.__isAmbassador = true;
    return __addInternalActivity;
}
/**
 * Adds a merchant comment to an order.
 * > **Note:** Activities with type CustomActivity not supported
 * @deprecated It has been replaced with com.wix.ecom.orders.v1.OrdersService.AddActivities(), and will be removed on 2024-11-01.
 */
export function addActivity(payload) {
    var _a = serializer(_addActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addActivityResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __addActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AddActivity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/activities',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addActivity.fromReq = fromReq;
    __addActivity.__isAmbassador = true;
    return __addActivity;
}
/**
 * Adds merchant comments to an order.
 * > **Note:** Activities with type CustomActivity not supported
 */
export function addActivities(payload) {
    var _a = serializer(_addActivitiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addActivitiesResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __addActivities(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AddActivities',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{orderId}/activities/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addActivities.fromReq = fromReq;
    __addActivities.__isAmbassador = true;
    return __addActivities;
}
/** Updates an order's activity. */
export function updateActivity(payload) {
    var _a = serializer(_updateActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateActivityResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateActivity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/activities/{activityId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateActivity.fromReq = fromReq;
    __updateActivity.__isAmbassador = true;
    return __updateActivity;
}
/**
 * Delete's an order's activity.
 *
 * Only custom activities and merchant comments can be deleted.
 */
export function deleteActivity(payload) {
    var _a = serializer(_deleteActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteActivityResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __deleteActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'DELETE',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.DeleteActivity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/activities/{activityId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteActivity.fromReq = fromReq;
    __deleteActivity.__isAmbassador = true;
    return __deleteActivity;
}
/** Updates an order's line item descriptions. */
export function updateLineItemsDescriptionLines(payload) {
    var _a = serializer(_updateLineItemsDescriptionLinesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLineItemsDescriptionLinesResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateLineItemsDescriptionLines(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateLineItemsDescriptionLines',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-line-items-description-lines',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLineItemsDescriptionLines.fromReq = fromReq;
    __updateLineItemsDescriptionLines.__isAmbassador = true;
    return __updateLineItemsDescriptionLines;
}
/** Marks an order as read in the dashboard. `order.seenByAHuman` field changes to `true`. */
export function markOrderAsSeenByHuman(payload) {
    var _a = serializer(_markOrderAsSeenByHumanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markOrderAsSeenByHumanResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __markOrderAsSeenByHuman(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkOrderAsSeenByHuman',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-seen-by-a-human',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markOrderAsSeenByHuman.fromReq = fromReq;
    __markOrderAsSeenByHuman.__isAmbassador = true;
    return __markOrderAsSeenByHuman;
}
/** Cancels an order. The `order.status` field changes to `CANCELED`. */
export function cancelOrder(payload) {
    var _a = serializer(_cancelOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelOrderResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __cancelOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CancelOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelOrder.fromReq = fromReq;
    __cancelOrder.__isAmbassador = true;
    return __cancelOrder;
}
/**
 * Updates order status.
 *
 * >CANCELED and REJECTED are final statuses. Update from either of those will fail.
 * >Updates into INITIALIZED are not supported.
 *
 * Approving order:
 * APPROVED status can be set while order has one of [INITIALIZED, PENDING] statuses.
 *
 * Approving an order which was created with CreateOrderRequest.settings.order_approval_strategy = PAYMENT_METHOD_SAVED
 * will cause an error.
 *
 * Setting PENDING status:
 * Only orders in INITIALIZED status can be updated into PENDING.
 */
export function updateOrderStatus(payload) {
    var _a = serializer(_updateOrderStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderStatusResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateOrderStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrderStatus',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{orderId}/update-status',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderStatus.fromReq = fromReq;
    __updateOrderStatus.__isAmbassador = true;
    return __updateOrderStatus;
}
/** Marks an order as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
export function markAsFulfilled(payload) {
    var _a = serializer(_markAsFulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsFulfilledResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __markAsFulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkAsFulfilled',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-fulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsFulfilled.fromReq = fromReq;
    __markAsFulfilled.__isAmbassador = true;
    return __markAsFulfilled;
}
/** Marks multiple orders as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
export function bulkMarkAsFulfilled(payload) {
    var _a = serializer(_bulkMarkAsFulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsFulfilledResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkMarkAsFulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsFulfilled',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-fulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsFulfilled.fromReq = fromReq;
    __bulkMarkAsFulfilled.__isAmbassador = true;
    return __bulkMarkAsFulfilled;
}
/** Marks multiple orders as fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `FULFILLED`. */
export function bulkMarkAsFulfilledByFilter(payload) {
    var _a = serializer(_bulkMarkAsFulfilledByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsFulfilledByFilterResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkMarkAsFulfilledByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsFulfilledByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-fulfilled-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsFulfilledByFilter.fromReq = fromReq;
    __bulkMarkAsFulfilledByFilter.__isAmbassador = true;
    return __bulkMarkAsFulfilledByFilter;
}
/** Marks an order as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
export function markAsUnfulfilled(payload) {
    var _a = serializer(_markAsUnfulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsUnfulfilledResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __markAsUnfulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkAsUnfulfilled',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-unfulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsUnfulfilled.fromReq = fromReq;
    __markAsUnfulfilled.__isAmbassador = true;
    return __markAsUnfulfilled;
}
/** Marks multiple orders as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
export function bulkMarkAsUnfulfilled(payload) {
    var _a = serializer(_bulkMarkAsUnfulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsUnfulfilledResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkMarkAsUnfulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsUnfulfilled',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-unfulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsUnfulfilled.fromReq = fromReq;
    __bulkMarkAsUnfulfilled.__isAmbassador = true;
    return __bulkMarkAsUnfulfilled;
}
/** Marks multiple orders as not fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
export function bulkMarkAsUnfulfilledByFilter(payload) {
    var _a = serializer(_bulkMarkAsUnfulfilledByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsUnfulfilledByFilterResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkMarkAsUnfulfilledByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsUnfulfilledByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-unfulfilled-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsUnfulfilledByFilter.fromReq = fromReq;
    __bulkMarkAsUnfulfilledByFilter.__isAmbassador = true;
    return __bulkMarkAsUnfulfilledByFilter;
}
/**
 * For INTERNAL use only.
 * Set business location for the multiple orders
 */
export function bulkSetBusinessLocation(payload) {
    var _a = serializer(_bulkSetBusinessLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkSetBusinessLocationResponse, {}).fromJSON;
    function __bulkSetBusinessLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkSetBusinessLocation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/set-business-location',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkSetBusinessLocation.fromReq = fromReq;
    __bulkSetBusinessLocation.__isAmbassador = true;
    return __bulkSetBusinessLocation;
}
/**
 * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
 * In case the order already has an offline payment transaction associated with it (usually when manual payment method is chosen at checkout) - This transaction will become approved.
 * In case the order has no payment transactions associated with it (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction will be created and approved.
 */
export function markOrderAsPaid(payload) {
    var _a = serializer(_markOrderAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markOrderAsPaidResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __markOrderAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkOrderAsPaid',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markOrderAsPaid.fromReq = fromReq;
    __markOrderAsPaid.__isAmbassador = true;
    return __markOrderAsPaid;
}
/** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
export function bulkMarkOrdersAsPaid(payload) {
    var _a = serializer(_bulkMarkOrdersAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkOrdersAsPaidResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __bulkMarkOrdersAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkOrdersAsPaid',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkOrdersAsPaid.fromReq = fromReq;
    __bulkMarkOrdersAsPaid.__isAmbassador = true;
    return __bulkMarkOrdersAsPaid;
}
/**
 * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
 * 1. An explicit amount provided in the request, or;
 * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
 * As a result, an ID of the created payment gateway order would be returned.
 * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
 */
export function createPaymentGatewayOrder(payload) {
    var _a = serializer(_createPaymentGatewayOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPaymentGatewayOrderResponse, {}).fromJSON;
    function __createPaymentGatewayOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CreatePaymentGatewayOrder',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{ecomOrderId}/create-payment-gateway-order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPaymentGatewayOrder.fromReq = fromReq;
    __createPaymentGatewayOrder.__isAmbassador = true;
    return __createPaymentGatewayOrder;
}
/**
 * returns shipping label ids - temporarily until fully modeled in fulfillments service
 * @deprecated Will be removed on 2023-05-15.
 */
export function getShipments(payload) {
    var _a = serializer(_getShipmentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getShipmentsResponse, {}).fromJSON;
    function __getShipments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.GetShipments',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/shipments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getShipments.fromReq = fromReq;
    __getShipments.__isAmbassador = true;
    return __getShipments;
}
export function aggregateOrders(payload) {
    var _a = serializer(_aggregateOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_aggregateOrdersResponse, {}).fromJSON;
    function __aggregateOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AggregateOrders',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/aggregate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __aggregateOrders.fromReq = fromReq;
    __aggregateOrders.__isAmbassador = true;
    return __aggregateOrders;
}
/** Restock items on order - temporary solution for POS */
export function decrementItemsQuantity(payload) {
    var _a = serializer(_decrementItemsQuantityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_decrementItemsQuantityResponse, {
        _activity: _activity,
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _focalPoint: _focalPoint,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _pickupAddress: _pickupAddress,
        _pickupDetails: _pickupDetails,
        _shippingInformation: _shippingInformation,
        _subscriptionInfo: _subscriptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __decrementItemsQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.DecrementItemsQuantity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/restock',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __decrementItemsQuantity.fromReq = fromReq;
    __decrementItemsQuantity.__isAmbassador = true;
    return __decrementItemsQuantity;
}
/**
 * Synchronously update tags on multiple orders, by list of order IDs.
 *
 * > **Note:** If the same tag is passed to both the `assignTags` and `unassignTags` fields, it will be assigned.
 */
export function bulkUpdateOrderTags(payload) {
    var _a = serializer(_bulkUpdateOrderTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateOrderTagsResponse, {}).fromJSON;
    function __bulkUpdateOrderTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkUpdateOrderTags',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateOrderTags.fromReq = fromReq;
    __bulkUpdateOrderTags.__isAmbassador = true;
    return __bulkUpdateOrderTags;
}
//# sourceMappingURL=http.impl.js.map